module.exports = __webpack_public_path__ + "fonts/VetoSans-Light_1.bca4b630.woff";